/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { Constants } from '../common/Constants';

/**
 * Create Office addin partner Id.
 *
 * @param documentId Document ID for OneDrive item.
 * @param driveId OneDrive id for document.
 * @param permissionId Document share link permission Id.
 * @return Partner Id.
 */
export const createApprovalsPermissionId = async (
    documentId: string,
    driveId: string,
    permissionId: string
): Promise<string> => {
    const documentPid = `${driveId}/${documentId}/${permissionId}`;

    await addApprovalsPermissionId(documentPid);
    return documentPid;
};

/**
 * Write ApprovalsPermissionId to document custom settings.
 *
 * @param documentPid Approval Permission ID.
 */
export const addApprovalsPermissionId = async (documentPid: string): Promise<void> => {
    return Word.run(async (context: Word.RequestContext): Promise<void> => {
        context.document.properties.customProperties.add(Constants.MST_APPROVALS_PERMISSION_ID, documentPid);

        await context.sync();
    });
};

/**
 * Read ApprovalsPermissionId from document settings.
 *
 * @return ApprovalsPermissionId.
 */
export const getApprovalsPermissionId = async (): Promise<string> => {
    return Word.run<string>(async (context: Word.RequestContext): Promise<string> => {
        const customProperty = context.document.properties.customProperties.getItemOrNullObject(
            Constants.MST_APPROVALS_PERMISSION_ID
        );
        customProperty.load('key,value');

        await context.sync();
        return customProperty.value;
    });
};
